import { dataUnlock } from 'dls-icons-data'
import { createIcon } from '../common'

const IconUnlock = /*#__PURE__*/createIcon(dataUnlock)
export default IconUnlock
